<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { configData } from '@/api/home'
export default {
  name: 'App',
  data() {
    return {
      mallKeywords: null,
      mallDesc: null,
      mallTitle: null,
      mallName: null
    }
  },
  mounted() {
    // =================
    const script = document.createElement('script')
    script.src = 'https://s13.cnzz.com/z_stat.php?id=1274041432&web_id=1274041432'
    script.language = 'JavaScript'
    document.body.appendChild(script)

    /* const translateScript = document.createElement('script')
    translateScript.src = 'https://res.zvo.cn/translate/translate.js'
    translateScript.language = 'JavaScript'
    document.body.appendChild(translateScript)
    translate.language.setLocal('chinese_simplified'); //设置本地语种（当前网页的语种）。如果不设置，默认就是 'chinese_simplified' 简体中文。 可填写如 'english'、'chinese_simplified' 等，具体参见文档下方关于此的说明
    translate.listener.start();    //开启html页面变化的监控，对变化部分会进行自动翻译。注意，这里变化区域，是指使用 translate.setDocuments(...) 设置的区域。如果未设置，那么为监控整个网页的变化
    translate.execute(); //执行翻译初始化操作，显示出select语言选择 */
    // =================
  },
  watch: {
    $route() {
      if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
      }
    }
  },
  created() {
    configData({ key: 'P_mallName', tips: '商城名称' }).then(res => {
      this.mallName = res.data.name
      configData({ key: 'P_mallTitle', tips: '商城标题' }).then(responese => {
        if (responese.data && responese.data.name && this.mallName) {
          document.title = responese.data.name
        } else {
          document.title = '鞋库网'
        }
      })
    })
    configData({ key: 'P_mallKeywords', tips: '商城关键字' }).then(res => {
      if (res.data && res.data.name) {
        document.querySelector('meta[name="Keywords"]').setAttribute('content', res.data.name)
      }
    })
    configData({ key: 'P_mallDescribe', tips: '商城描述' }).then(res => {
      if (res.data && res.data.name) {
        document.querySelector('meta[name="Description"]').setAttribute('content', res.data.name)
      }
    })
    //上报统计
    configData({ key: 'J_statisticsCode', tips: '页面统计代码' }).then(res => {
      if (res.data && res.data.name) {
        const head = window.document.getElementsByTagName('body')[0]
        let script=document.createElement('script');
        const scripts=res.data.name.replace(/<\/?.+?>/g,"");
        script.innerHTML=scripts;
        head.append(script)
        //document.querySelector('meta[name="Description"]').setAttribute('content', res.data.name)
      }
    })


    // configData({ key: 'K_mapKey', tips: '腾讯地图密钥' }).then(res => {
    //   if (res.data && res.data.name) {
    //     //创建script标签，并设置src属性添加到body中
    //     var script = document.createElement("script");
    //     script.type = "text/javascript";
    //     script.src = `https://map.qq.com/api/js?v=2.exp&key=`+ res.data.name;
    //     document.body.appendChild(script);
    //   }
    // })

  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue